export const readStoredValue = key => {
  try {
    return localStorage.getItem(key)
  } catch (error) {
    return null
  }
}

export const readStoredUser = () => {
  try {
    const user = JSON.parse(readStoredValue('userData'))
    if (!user || typeof user !== 'object' || Array.isArray(user) || !Array.isArray(user.roles)
      || !user.roles.length || !user.roles.every(role => typeof role === 'string' && role.trim())) return null
    return user
  } catch (error) {
    return null
  }
}
